import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SearchField from '../../../home/components/filters/SearchField'
import FilterDateRangeV2 from '../../../home/components/filters/FilterDateRangeV2'
import FilterProductType from './FilterProductType'
import BatchesPartner from "../../../batchesV3/components/filters/BatchesPartner"
import BatchesPartnerSew from "./BatchesPartnerSew"
import SelectFilterOptions from '../../../shared/SelectFilterOptions'
import NumberFilterOptions from '../../../shared/NumberFilterOptions'
import {BATCH_PRIORITY, OPTIONS_OVERTIME, MERGE_STATUS, TAGS, MEX_OPTIONS, NEED_CUT_LASZER_OPTIONS, CHEAP_PRODUCTS_OPTIONS, PRINT_QR, BATCH_EMBROIDERY} from "../../../../helpers/ListOptions.json"
import { Select, Checkbox } from 'antd'
import FilterMaterials from '../../../batchesV3/components/filters/FilterMaterials'
import FilterUserCut from '../../../list-laze/components/FilterUserCut'
import { getListProductionProcess } from '../../../../services/api/3dApi'
import FilterSkuPartner from '../../../shared/FilterSkuPartner'

class BatchProductionStatusPageFilters extends Component {
    constructor(props) {
        super(props)
        const {typeOverTime} = props

        this.state = {
            printed_overtime: '',
            transferred_overtime: '',
            sewing_overtime: '',
            [typeOverTime]: 'yn',
            isEmbroidery: false,
            listProductionProcess: [],
        }
    }

    _handleChangeField = (field, value) => {
        const {handleChangeInput} = this.props
        if ([
            'brand',
            'batch_overtime',
            'tags',
            'is_mex_sku',
            'need_cut_laze',
            'presser_number',
            'is_cheap_product',
            'printed_qr',
            'partner',
            'embroidery_batch_statistic',
            'received_laser_user',
            'laser_cutter_name',
            'production_partner',
        ].includes(field)) {
            handleChangeInput(field,value)
        }else{
            handleChangeInput(field, value.trim())
        }
    }

    _handleChangeFieldNew = (filter) => {
        const {onChangeInputNew} = this.props
        onChangeInputNew(filter)
    }

    _handleChangeName = (field, value) => {
        const {handleChangeInput} = this.props
        const newValues = value.trim().split(/,|\r|\n|\t|\r\n|\s|,\s|,/)

        if (typeof handleChangeInput === 'function') {
            handleChangeInput(field, [...new Set(newValues)])
        }
    }

    _handleChangeDate = (field, value) => {
        const {handleChangeDate} = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') {
            delete cloneFilter[field]
        }

        handleChangeDate(cloneFilter)
    }

    _handleChangeOverTime = (field, value) => {
        this.setState({
            [field]: value
        }, () => {
            const {handleChangeDate} = this.props
            const cloneFilter = Object.assign({}, this.props.filters)

            value !== 'days' && delete cloneFilter[field]

            switch (value) {
                case 'y':
                    cloneFilter[field] = {from: 0}
                    break
                case 'yy':
                    cloneFilter[field] = {from: 0, phase_status: 'completed'}
                    break
                case 'yn':
                    cloneFilter[field] = {from: 0, phase_status: 'not_completed'}
                    break
                case 'n':
                    cloneFilter[field] = {to: 0}
                    break
                default:
            }

            if (value !== 'days') {
                handleChangeDate(cloneFilter)
            } else if (typeof cloneFilter[field] === "object") {
                delete cloneFilter[field]['phase_status']
                delete cloneFilter[field]['from']
            }
        })
    }

    _handleChangeOverDayPrinted = (e) => {
        const {name, value} = e.target
        const {handleChangeDate} = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter['printed_overtime'] = {...cloneFilter['printed_overtime'], [name]: parseInt(value, 0)}

        if (value === null || value === '') {
            delete cloneFilter['printed_overtime'][name]
        }

        if (!cloneFilter['printed_overtime'].hasOwnProperty('from') && !cloneFilter['printed_overtime'].hasOwnProperty('to')) {
            delete cloneFilter['printed_overtime']
        }

        handleChangeDate(cloneFilter)
    }

    _handleChangeOverDayTransformed = (e) => {
        const {name, value} = e.target
        const {handleChangeDate} = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter['transferred_overtime'] = {...cloneFilter['transferred_overtime'], [name]: parseInt(value, 0)}

        if (value === null || value === '') {
            delete cloneFilter['transferred_overtime'][name]
        }

        if (!cloneFilter['transferred_overtime'].hasOwnProperty('from') && !cloneFilter['transferred_overtime'].hasOwnProperty('to')) {
            delete cloneFilter['transferred_overtime']
        }

        handleChangeDate(cloneFilter)
    }

    _handleChangeOverDaySewing = (e) => {
        const {name, value} = e.target
        const {handleChangeDate} = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter['sewing_overtime'] = {...cloneFilter['sewing_overtime'], [name]: parseInt(value, 0)}

        if (value === null || value === '') {
            delete cloneFilter['sewing_overtime'][name]
        }

        if (!cloneFilter['sewing_overtime'].hasOwnProperty('from') && !cloneFilter['sewing_overtime'].hasOwnProperty('to')) {
            delete cloneFilter['sewing_overtime']
        }

        handleChangeDate(cloneFilter)
    }

    getOptionOverTime = (start, end) => {
        const Options = []
        for (let i = start; i <= end; i++) {
            if(i !==0){
                const Option = {
                    name: i,
                    value: i,
                }
                if(i === -1) {
                    Options.push({name: -1.5,value: -1.5,})
                }
                Options.push(Option)
            }
        }
        return Options
    }

    _fetchListProductionProcess = async () => {
        const payload = { page: 1, pageSize: 10000, name: 'thêu' }
        try {
            const { data: res } = await getListProductionProcess(payload)
            const { success, message: mess, data } = res || {}
            if (!success) {
                throw new Error(mess)
            }
            const { result = [] } = data || {}
            this.setState({ listProductionProcess: result })
        } catch (error) {
            console.log(error.message)
        }
    }

    componentDidMount() {
        this._fetchListProductionProcess()
    }

    _onchangeCheckbox = (field, e) => {
        const { listProductionProcess = [] } = this.state
        const { handleChangeInput } = this.props
        if (field === 'Thêu') {
            const newData = listProductionProcess.find(i => i.name.toLowerCase() === 'thêu')
            this.setState({
                isEmbroidery: e.target.checked ? (newData._id || '') : ''
            })
            handleChangeInput('production_process', e.target.checked ? (newData._id || '') : '')
        }
    }

    render() {
        const { printed_overtime, transferred_overtime, sewing_overtime, isEmbroidery } = this.state
        const { filters, onChangeProductType, showPartner, merge_file_status, listBrand, listMaterials, onChangeMaterials } = this.props
        const { level, batch_overtime, status } = filters
        const Option = Select.Option
        const disableNoBrand = !!filters.brand && filters.brand.length > 0 && !filters.brand.includes('no brand')
        const disableOptionBrand = !!filters.brand && filters.brand.length > 0 && filters.brand.includes('no brand')
        let optionPress = []

        for (let i = 0; i < 7; i++) {
            optionPress.push({ name: `Máy ép ${i + 1}`, value: i + 1 })
        }

        return (
            <div className='BatchesPageContainer'>
                <div className='row align-items-starts'>
                    <div className='FilterLevel col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            field="level" label="Độ ưu tiên"
                            defaultValue={level}
                            style={{width: '100%'}}
                            handleChange={this._handleChangeField}
                            listOptions={BATCH_PRIORITY}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3 FilterNameBatch'>
                        <label className="font-weight-bold d-block">Tên lô</label>
                        <SearchField
                            placeholder='Tìm kiếm theo tên Lô...'
                            field='name'
                            onChangeInput={this._handleChangeName}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="d-block font-weight-bold">Người tạo lô</label>
                        <SearchField
                            placeholder='Tìm kiếm theo người tạo ...'
                            onChangeInput={this._handleChangeField}
                            field='user_create'
                        />
                    </div>

                    <div className='col-12 col-xl-4 mb-3'>
                        <label className="d-block font-weight-bold">Loại sản phẩm</label>
                        <FilterProductType
                            onChangeProductType={onChangeProductType}
                            productTypes={filters.product_types}
                        />
                    </div>


                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày tạo lô</label>
                        <FilterDateRangeV2 field='created_at' onDatesChange={this._handleChangeDate}/>
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày ép</label>
                        <FilterDateRangeV2 field='transferred_at' filters={filters} onDatesChange={this._handleChangeDate} showTime/>
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày in lô</label>
                        <FilterDateRangeV2 field='printed_at' onDatesChange={this._handleChangeDate}/>
                    </div>
                    {
                        showPartner && (
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Ngày giao may</label>
                                <FilterDateRangeV2 field='sewing_at' filters={filters} onDatesChange={this._handleChangeDate} showTime/>
                            </div>
                        )
                    }

                    {
                        showPartner && (
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Ngày nhận may</label>
                                <FilterDateRangeV2 field='receive_sew_at' onDatesChange={this._handleChangeDate}/>
                            </div>
                        )
                    }

                    {showPartner && <BatchesPartner onChangePartner={this._handleChangeField}/>}

                    {showPartner && <BatchesPartnerSew
                        filters={filters}
                        onChangePartner={this._handleChangeFieldNew}
                        isShowSewingPartner={this.props.isShowSewingPartner}
                        isSewingGroup={this.props.isSewingGroup}
                        onChangeCheckBox={this.props.onChangeCheckBox}
                        disabled={(filters.production_partner || []).length > 0}
                    />}

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            label="Trạng thái gộp"
                            defaultValue={merge_file_status}
                            listOptions={MERGE_STATUS}
                            style={{width: '100%'}}
                            handleChange={this._handleChangeField}
                            field="merge_file_status" 
                        />
                    </div>


                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            label="Thời gian quá hạn In"
                            defaultValue={printed_overtime}
                            listOptions={OPTIONS_OVERTIME}
                            style={{width: '100%'}}
                            handleChange={this._handleChangeOverTime}
                            field="printed_overtime" 
                        />
                    </div>

                    {
                        printed_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    placeholder="từ"
                                    field='from'
                                    handleChange={this._handleChangeOverDayPrinted}
                                    defaultValue={filters.printed_overtime !== undefined ? filters.printed_overtime.from : ''}
                                />
                            </div>
                        )
                    }

                    {
                        printed_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    placeholder="đến"
                                    field='to'
                                    handleChange={this._handleChangeOverDayPrinted}
                                    defaultValue={filters.printed_overtime !== undefined ? filters.printed_overtime.to : ''}
                                />
                            </div>
                        )
                    }

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            label="Thời gian quá hạn Ép"
                            defaultValue={transferred_overtime}
                            listOptions={OPTIONS_OVERTIME}
                            style={{width: '100%'}}
                            handleChange={this._handleChangeOverTime}
                            field="transferred_overtime"
                        />
                    </div>

                    {
                        transferred_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    placeholder="từ"
                                    field='from'
                                    handleChange={this._handleChangeOverDayTransformed}
                                    defaultValue={filters.transferred_overtime !== undefined ? filters.transferred_overtime.from : ''}
                                />
                            </div>
                        )
                    }

                    {
                        transferred_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    placeholder="đến"
                                    field='to'
                                    handleChange={this._handleChangeOverDayTransformed}/>
                                    defaultValue={filters.transferred_overtime !== undefined ? filters.transferred_overtime.to : ''}
                            </div>
                        )
                    }

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            label="Thời gian quá hạn May"
                            defaultValue={sewing_overtime}
                            listOptions={OPTIONS_OVERTIME}
                            style={{width: '100%'}}
                            handleChange={this._handleChangeOverTime}
                            field="sewing_overtime"
                        />
                    </div>

                    {
                        sewing_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    placeholder="từ"
                                    field='from'
                                    handleChange={this._handleChangeOverDaySewing}
                                    defaultValue={filters.sewing_overtime !== undefined ? filters.sewing_overtime.from : ''}
                                />
                            </div>
                        )
                    }

                    {
                        sewing_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    placeholder="đến"
                                    field='to'
                                    handleChange={this._handleChangeOverDaySewing}
                                    defaultValue={filters.sewing_overtime !== undefined ? filters.sewing_overtime.to : ''}
                                />
                            </div>
                        )
                    }

                    <div className='col-12 col-xl-2 mb-3 filterBrand RequestSelect'>
                        <div className="SelectFilterOption">
                            <label htmlFor="request_update" className="d-block w-100 font-weight-bold">Brand</label>
                            <Select
                                name='brand'
                                className='brand'
                                mode={'multiple'}
                                onChange={( value ) => this._handleChangeField( 'brand', value )}
                                value={filters.brand}
                                allowClear
                                placeholder='Chọn brand name'
                                style={{ width: '100%', maxWidth:'460px' }}
                            >
                                <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                {listBrand.length && listBrand.map((i, index) => (
                                    <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                                ))
                                }
                            </Select>
                        </div>
                    </div>

                    <div className='col-12 col-xl-2 mb-3 filterBrand RequestSelect'>
                    <SelectFilterOptions
                            defaultValue={batch_overtime}
                            listOptions={this.getOptionOverTime(-6,6)}
                            style={{width: '100%'}}
                            field="batch_overtime" label="Thời gian item quá hạn"
                            handleChange={this._handleChangeField}
                            mode='multiple'
                            showArrow
                            allowClear
                            placeholder='Chọn thời gian item quá hạn'
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3 filterBrand RequestSelect'>
                    <SelectFilterOptions
                            defaultValue={[]}
                            listOptions={TAGS}
                            style={{width: '100%'}}
                            field="tags" label="Tag"
                            handleChange={this._handleChangeField}
                            mode='tags'
                            showArrow
                            allowClear
                            placeholder='Chọn tag'
                            isMultiple={true}
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={filters.is_mex_sku || []}
                            listOptions={MEX_OPTIONS}
                            style={{ width: '100%' }}
                            field="is_mex_sku" label="Ép mex"
                            placeholder='Chọn ép mex'
                            handleChange={this._handleChangeField}
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={filters.need_cut_laze || []}
                            listOptions={NEED_CUT_LASZER_OPTIONS}
                            style={{width: '100%'}}
                            field="need_cut_laze"
                            label="Cắt laze"
                            placeholder='Chọn cắt laze'
                            handleChange={this._handleChangeField}
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Người nhận cắt laze</label>
                        <FilterUserCut
                            usersCut={filters.received_laser_user || []}
                            onChangeUsersCut={(value) => this._handleChangeField('received_laser_user', value)}
                            placeholder='Chọn người nhận cắt'
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Người cắt laze</label>
                        <FilterUserCut
                            usersCut={filters.laser_cutter_name || []}
                            onChangeUsersCut={(value) => this._handleChangeField('laser_cutter_name', value)}
                            placeholder='Chọn người cắt'
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày nhận cắt laze</label>
                        <FilterDateRangeV2 field='received_laser_at' onDatesChange={this._handleChangeDate}/>
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={filters.is_cheap_product || []}
                            listOptions={CHEAP_PRODUCTS_OPTIONS}
                            style={{width: '100%'}}
                            field="is_cheap_product"
                            label="Sản phẩm giá rẻ"
                            placeholder='Chọn sản phẩm giá rẻ'
                            handleChange={this._handleChangeField}
                            allowClear
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Thời điểm may xong</label>
                        <FilterDateRangeV2 field='sewed_at' onDatesChange={this._handleChangeDate} showTime/>
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={[]}
                            listOptions={optionPress}
                            style={{ width: '100%' }}
                            field="presser_number" label="Máy ép"
                            placeholder='Chọn máy ép'
                            allowClear
                            handleChange={this._handleChangeField}
                            isMultiple={true}
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={filters.printed_qr || []}
                            listOptions={PRINT_QR}
                            style={{ width: '100%' }}
                            field="printed_qr" label="In QR"
                            handleChange={this._handleChangeField}
                            allowClear
                            placeholder='Chọn in QR'
                        />
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="d-block font-weight-bold">Nguyên vật liệu</label>
                        <FilterMaterials
                            materials={filters.materials}
                            onChangeMaterials={onChangeMaterials}
                            listOptions={listMaterials}
                        />
                    </div>
                    {/* <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block" style={{ height: 21 }}></label>
                        <div className='d-flex align-items-center justify-content-between' style={{ height: 32 }}>
                            <Checkbox checked={isEmbroidery} className='font-weight-bold' onChange={(e) => this._onchangeCheckbox('Thêu', e)}>Thêu</Checkbox>
                            {
                                isEmbroidery &&
                                <div className='FilterStatus' style={{marginBottom: '30px'}}>
                                    <SelectFilterOptions
                                        allowClear
                                        defaultValue={filters.embroidery_batch_statistic || []}
                                        listOptions={BATCH_EMBROIDERY}
                                        style={{ width: '100%' }}
                                        field="embroidery_batch_statistic" label="Lô thêu"
                                        handleChange={this._handleChangeField}
                                        placeholder='Chọn lô thêu'
                                    />
                                </div>
                            }
                        </div>
                    </div> */}
                    {
                        isEmbroidery &&
                        <div className='col-12 col-xl-2 mb-3'>
                            <label className="d-block font-weight-bold">Thời gian thiết kế thêu</label>
                            <FilterDateRangeV2
                                showTime
                                field='designed_at'
                                filters={filters}
                                onDatesChange={this._handleChangeDate}
                            />
                        </div>
                    }
                    <FilterSkuPartner
                        value={filters.production_partner || []}
                        onChange={(value) => this._handleChangeField('production_partner', value)}
                        disabled={
                            (filters.without_sewing_group || false) ||
                            (filters.without_sewing_partner || false) ||
                            ((filters.mutiple_sewing_partner || []).length > 0)
                        }
                    />
                </div>
            </div>
        )
    }

}

BatchProductionStatusPageFilters.defaultProps = {
    showPartner: true
}

BatchProductionStatusPageFilters.propTypes = {
    showPartner: PropTypes.bool,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    handleChangeInput: PropTypes.func.isRequired,
    onChangeProductType: PropTypes.func.isRequired
}

export default BatchProductionStatusPageFilters